<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_11123_43928)">
      <path
        d="M13.5 2.49609H2.5C2.22386 2.49609 2 2.76472 2 3.09609V13.8961C2 14.2275 2.22386 14.4961 2.5 14.4961H13.5C13.7761 14.4961 14 14.2275 14 13.8961V3.09609C14 2.76472 13.7761 2.49609 13.5 2.49609Z"
        stroke="#868D9C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.75 7.5C10.1642 7.5 10.5 7.16421 10.5 6.75C10.5 6.33579 10.1642 6 9.75 6C9.33579 6 9 6.33579 9 6.75C9 7.16421 9.33579 7.5 9.75 7.5Z"
        fill="#868D9C"
      />
      <path
        d="M9.20703 10.7501L10.8127 9.14633C10.9064 9.05263 11.0335 9 11.1661 9C11.2986 9 11.4258 9.05263 11.5195 9.14633L14.0002 11.6288"
        stroke="#868D9C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2 12.0435L5.39625 8.64664C5.44269 8.60015 5.49783 8.56328 5.55853 8.53811C5.61923 8.51295 5.68429 8.5 5.75 8.5C5.81571 8.5 5.88077 8.51295 5.94147 8.53811C6.00217 8.56328 6.05731 8.60015 6.10375 8.64664L11.9569 14.5004"
        stroke="#868D9C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_11123_43928">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
